import React, { useCallback, useEffect, useState } from 'react';
import icons from '../../assets/img/icons.svg';
import { NoReports, TileLoader } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import { deleteAllAssets, fetchAllAssets } from '../../actions/targets/assets.action';
import AssetsTable from '../../components/viewer/mgmt/AssetsTable';
import CreateModal from '../../components/common/createModal';
import { CREATE_MODALS } from '../../constant/insights';
import NewAssetModal from './NewAssetModal';

const AssetsOverview = ({ newAssetModalOpen, setNewAssetModalOpen }) => {
  const [loading, setLoading] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [assetsTable, setAssetsTable] = useState([]);
  const [assetToDelete, setAssetToDelete] = useState(null);
  const [assetToAccess, setAssetToAccess] = useState(null);
  const [modalOpened, setModalOpened] = useState(null);
  const assets = useSelector((state) => state.assets.assetsModalProps.assets);
  const reduxLoading = useSelector((state) => state.assets.assetsModalProps.loading);
  const dispatch = useDispatch();

  const updateSearchedKeyword = () => {
    if (searchKeyword.trim() !== '') {
      const filteredOptions = assets.filter(({ name }) =>
        name.toLowerCase().trim().includes(searchKeyword.toLowerCase().trim()),
      );
      setAssetsTable(filteredOptions);
    } else {
      setAssetsTable(assets);
    }
  };

  const clearSearchFilter = () => {
    setSearchKeyword('');
    setAssetsTable(assets);
  };

  const handleDeleteConfirmation = (asset) => {
    setAssetToDelete(asset);
    setModalOpened(CREATE_MODALS.DELETE);
  };

  const handleDelete = async () => {
    try {
      await dispatch(deleteAllAssets(assetToDelete.id));
      setAssetToDelete(null);
    } catch (error) {
      console.error(error);
    }
  };

  const handleAccessClick = (asset) => {
    setAssetToAccess(asset);
    setModalOpened(CREATE_MODALS.ACCESS);
  };

  const handleGetData = useCallback(async () => {
    await dispatch(fetchAllAssets());
    setLoading(false);
  }, [dispatch]);

  useEffect(() => {
    if (searchKeyword) {
      updateSearchedKeyword();
    } else {
      setAssetsTable(assets);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchKeyword, assets]);

  useEffect(() => {
    handleGetData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <section className="panel table targets">
        {!assetsTable.length && (loading || reduxLoading) ? (
          <TileLoader />
        ) : (
          <>
            <header className="filter">
              <div className="table-filter">
                <input
                  placeholder="Filter by keyword"
                  className="clearable kwrd-srch"
                  onChange={(e) => {
                    setSearchKeyword(e.target.value);
                    updateSearchedKeyword();
                  }}
                  value={searchKeyword}
                />
                <svg className="icon">
                  <use xlinkHref={`${icons}#action-search`} />
                </svg>
                <div className="clear-table-filter" onClick={clearSearchFilter}>
                  <svg className="icon">
                    <use xlinkHref={`${icons}#action-close`} />
                  </svg>
                </div>
              </div>
            </header>
            {assetsTable.length ? (
              <div className="scroller horz">
                <AssetsTable
                  tableData={assetsTable}
                  headRows={assetsTable}
                  handleDelete={handleDeleteConfirmation}
                  onAccessClick={handleAccessClick}
                />
              </div>
            ) : (
              <NoReports />
            )}
          </>
        )}
        {newAssetModalOpen && <NewAssetModal modalOpen={newAssetModalOpen} setModalOpen={setNewAssetModalOpen} />}
      </section>
      {(modalOpened === CREATE_MODALS.DELETE || modalOpened === CREATE_MODALS.ACCESS) && (
        <CreateModal
          newElementModalOpen={modalOpened}
          setNewElementModalOpen={setModalOpened}
          deleteAction={handleDelete}
          deleteItem={assetToDelete?.name}
          assetToAccess={assetToAccess}
        />
      )}
    </>
  );
};

export default AssetsOverview;
